import { api } from './api';

export async function registerFeedbackMessage(payload: any) {
  const { data } = await api.post(`database/feedback__c`, { ...payload, time: new Date().getTime() });
  return data;
}
